import React, { useState, useEffect} from 'react'
import Button from './../components/forms/Button'
import DefaultMonthlyEventItem from './../components/forms/MonthlyEventItems'

import {Link} from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import { fetchAllApptsStart } from '../redux/Appointments/appts.actions';
import { startOfMonth } from 'date-fns';
import {
  MonthlyBody,
  MonthlyDay,
  MonthlyCalendar,
  MonthlyNav
} from '@zach.codes/react-calendar';
import '@zach.codes/react-calendar/dist/calendar-tailwind.css';

import DashAuthWrapper from './../components/DashAuthWrapper'

const mapState = ({ user, apptsData }) => ({
	currentUser: user.currentUser,
	appts: apptsData.appts,
})

const Calendar = () => {
	const { appts, currentUser } = useSelector(mapState);
	const dispatch = useDispatch();
	const [currentMonth, setCurrentMonth] = useState(
		startOfMonth(new Date())
	  );
	

	const { apptData } = appts;

	useEffect(() => {
		dispatch(
			fetchAllApptsStart()
		);
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		window.scrollTo(0, 0)
	  }, [])


	// filter appts by custID
	const customerAppts = [];
	if(Array.isArray(apptData)){
		for(let i = 0; i < apptData.length; i++){
			if(apptData[i].custsID === `${currentUser.id}`){
				customerAppts.push(apptData[i]);
			}
		}
	}


	const congfigAuthWrapper = {
		headline: 'Calendar/ Appointments'
	}
	
	
	return (
		<div className="pb-5">
			{!currentUser.subscribed &&(
				<DashAuthWrapper>
					<h3 className="mt-5">You currently have no subscription</h3>
				
					<h3>Please 
						<Link to="/services">
							<Button>
								SUBSCRIBE
							</Button>
						</Link>
						to be eligible for services
					</h3>
				</DashAuthWrapper>
			)}

			{currentUser.subscribed &&(
				<DashAuthWrapper {...congfigAuthWrapper} className="pt0">
					<hr></hr>
				<MonthlyCalendar
      				currentMonth= {currentMonth}
     				onCurrentMonthChange={date => setCurrentMonth(date)}
    			>
      			<MonthlyNav />
      			<MonthlyBody
				
					events={

						customerAppts.map((appts, index) => {
							const {
								startDate,
								productName,
								documentID
							} = appts;
							
							return (

								


								{title: `${productName}`, date: new Date(`${startDate.toDate()}`), document: `${documentID}`}

							)})

								
					}
					>
						
					<MonthlyDay



					renderDay={data =>
						
						data.map((item, index) => (
							
						<DefaultMonthlyEventItem
						key={index}
						title={item.title}
						document={item.document}
						
							// Format the date here to be in the format you prefer
							// date={format(item.date, 'MMM dd, yyyy')}
						
						/>
					
							)
							
							)
						}
						/>
      			</MonthlyBody>
    		</MonthlyCalendar>
	
			
			</DashAuthWrapper>
			)}
		</div>		
		


		
	)
}

export default Calendar;